/**
 * @Description V2Container的children内容
 */
import { FC, useState, useEffect, useMemo, useRef } from 'react';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import styles from '../index.module.less';
import FirstScreenMap from './FirstScreenMap';
import FirstScreenRight from './FirstScreenRight';
import TypeOfBusiness from './TypeOfBusiness/TypeOfBusiness';
import POIMating from './TypeOfBusiness/POIMating';
// import PassengerFlowPortrait from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/PassengerFlowPortrait';
import PassengerFlowPortrait from '@/common/components/business/PassengerFlowPortrait';

import { spotEvaluationLegend, spotEvaluationLegendShare, spotEvaluationPopulation, spotEvaluationPopulationShare } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '../../../ts-config';

const Main: FC<any> = ({
  drawerData,
  mainHeight,
  detail,
  overViewData,
  isMallType,
  tenantId,
  configSwitch,
  shareParams,
}) => {
  const [mapIns, setMapIns] = useState<any>(null); // 地图实例
  const [tmpLegendData, setTmpLegendData] = useState<any>([]); // 图例原始数据
  const [storeOptions, setStoreOptions] = useState<any>({}); // 经营门店所有tab展示选项
  const [surroundingOptions, setSurroundingOptions] = useState<any>({}); // 周边配套所有tab展示选项
  const [storeChecked, setStoreChecked] = useState<any>({}); // 经营门店选中项
  const [surroundingChecked, setSurroundingChecked] = useState<any>({}); // 周边配套选中项
  const [ageDetail, setAgeDetail] = useState<any>({}); // 年龄分布
  const [curDetail, setCurDetail] = useState<any>(null);// 经营门店或周边配套选中的表格项
  const [isOpenHeatMap, setIsOpenHeatMap] = useState<boolean>(false);// 是否打开热力

  const rangeMarkerRef = useRef<any>({
    markerOf500: null,
    markerOf1500: null,
    markerOf3000: null,
  });

  useEffect(() => {
    const { open, lng, lat } = drawerData || {};
    if (open && lng && lat) {
      methods.loadLegend();
      methods.loadAgeDetail();
    }
  }, [drawerData]);

  /**
   * @description 图例展示项，只展示有数据的类型
   *
   *  tmpLegendData 接口返回图例/api/surround/poi/legend
   *  storeOptions 所有展示的门店类型 接口获取/api/surround/poi/level_count
   *  surroundingOptions 所有展示的周边配套类型 接口获取/api/surround/model/arroundCategory
   * @return
   */
  const legendData = useMemo(() => {
    if (!isArray(tmpLegendData)) return [];

    const stores = isArray(storeOptions) ? storeOptions : [];
    const surrounds = isArray(surroundingOptions) ? surroundingOptions : [];
    const list = tmpLegendData.filter((itm: any) => {
      const { key, code, aoiTypeCategoryId } = itm;
      // 机会点图例，或者属于有数据展示的门店类型，周边配套
      const isChance = ['MALL_CHANCE_POINT', 'CHANCE_POINT'].includes(key);
      const isStores = !!code && stores.some((st: any) => st.code === code);
      const isSurround = surrounds.some((srd: any) => srd.id === aoiTypeCategoryId);
      return isChance || isStores || isSurround;
    });
    return list;
  }, [tmpLegendData, storeOptions, surroundingOptions]);

  const methods = useMethods({
    loadAgeDetail: async () => {
      const api = tenantId ? spotEvaluationPopulationShare : spotEvaluationPopulation;
      const { type, modelClusterId, lng, lat, radius, modelConfigId } = drawerData;
      const params: any = {
        type,
        modelConfigId
      };
      if (tenantId) {
        params.tenantId = tenantId;
      }
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
      }
      if (type === SpotTypeEnum.Street) {
        params.lng = lng;
        params.lat = lat;
        params.radius = radius;
      }
      // const params = {
      //   lng: drawerData.lng,
      //   lat: drawerData.lat,
      //   tenantId,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId
      // };
      const ageDetailRes = await api(params);
      setAgeDetail(ageDetailRes);
    },
    loadLegend: async () => {
      const api = tenantId ? spotEvaluationLegendShare : spotEvaluationLegend;
      const { type, radius, modelConfigId, modelClusterId, lng, lat } = drawerData;
      const params: any = {
        type,
        modelConfigId,
      };
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
      }
      if (type === SpotTypeEnum.Street) {
        params.radius = radius;
        params.lng = lng;
        params.lat = lat;
      }
      if (tenantId) {
        params.tenantId = tenantId;
      }
      // const data = await api({
      //   lng: drawerData.lng,
      //   lat: drawerData.lat,
      //   tenantId,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId
      // });
      const data = await api(params);
      const targetData = (isArray(data) ? data : []).filter((item) => item.key !== 'CHANCE_POINT').map((item) => ({
        ...item,
        handSwitch: false, // 记录手动开关
        automaticSwitch: false, // 记录自动开关
      }));
      setTmpLegendData(targetData);
    }
  });
  return (
    <div
      className={styles.mainCon}
      style={{
        height: mainHeight,
        overflow: 'auto'
      }}
    >
      <div
        className={styles.firstScreenCon}
        style={{
          height: mainHeight,
        }}
      >
        {/* 地图部分 */}
        <FirstScreenMap
          detail={detail}
          drawerData={drawerData}
          mainHeight={mainHeight}
          mapIns={mapIns}
          storeChecked={storeChecked}
          surroundingChecked={surroundingChecked}
          legendData={legendData}
          isMallType={isMallType}
          setMapIns={setMapIns}
          curDetail={curDetail}
          setCurDetail={setCurDetail}
          tenantId={tenantId}
          rangeMarkerRef={rangeMarkerRef}
          isOpenHeatMap={isOpenHeatMap}
        />
        {/* 首屏右侧区域内容 */}
        <FirstScreenRight
          detail={detail}
          drawerData={drawerData}
          overViewData={overViewData}
          setStoreChecked={setStoreChecked}
          setSurroundingChecked={setSurroundingChecked}
          curDetail={curDetail}
          setCurDetail={setCurDetail}
          setStoreOptions={setStoreOptions}
          setSurroundingOptions={setSurroundingOptions}
          tenantId={tenantId}
          mapIns={mapIns}
          rangeMarkerRef={rangeMarkerRef}
          setIsOpenHeatMap={setIsOpenHeatMap}
          configSwitch={configSwitch}
          shareParams={shareParams}
        />
      </div>

      {/* 非首屏的懒加载区域 */}
      <div style={{ padding: '0 40px' }}>
        {/* 业态&配套分析 */}
        <TypeOfBusiness detail={detail} />
        <POIMating detail={detail} drawerData={drawerData} tenantId={tenantId}/>

        {/* 客流画像 */}
        <PassengerFlowPortrait ageDetail={ageDetail} overViewData={detail}/>
      </div>
    </div>
  );
};

export default Main;

